import classNames from 'classnames'

interface IGetRequestClass {
  status: string
  action: string
  modified: string
  styles: {
    readonly [key: string]: string
  }
}

export const getRequestClass = ({ action, modified, status, styles }: IGetRequestClass) => {
  let styleStatus = ''
  if (status === 'WIP') {
    styleStatus = styles['requests--wip']
  } else if (status === 'Done' && modified && Date.parse(modified) > +new Date() - 86400000) {
    styleStatus = styles['requests--done']
  } else if (status === 'Rejected') {
    styleStatus = styles['requests--rejected']
  } else if (status === 'New') {
    styleStatus = styles['requests--new']
  }

  let styleAction = ''
  if (action === 'Delete') {
    styleAction = styles['requests--delete']
  }

  return classNames(styleAction, styleStatus)
}
